<template>
  <div class="container-fluid bg-dark text-light">
    <div class="row gx-0 d-none d-lg-flex">
      <div class="col-lg-7 px-5 text-start">
        <div class="h-100 d-inline-flex align-items-center me-4">
          <span class="fa fa-phone-alt me-2"></span>
          <span>+49 173 9726335</span>
        </div>
        <div class="h-100 d-inline-flex align-items-center">
          <span class="far fa-envelope me-2"></span>
          <span>gartenbau.gazi@gmail.com</span>
        </div>
      </div>
      <div class="col-lg-5 px-3 text-end">
        <div class="h-100 d-inline-flex align-items-center mx-n2">
          <span>Folgen Sie uns:</span>
          <a class="btn btn-link text-light" href=""
            ><i class="fab fa-facebook-f"></i
          ></a>
          <!-- <a class="btn btn-link text-light" href=""
            ><i class="fab fa-twitter"></i
          ></a>
          <a class="btn btn-link text-light" href=""
            ><i class="fab fa-linkedin-in"></i
          ></a> -->
          <a
            class="btn btn-link text-light"
            href="https://www.instagram.com/gartenbau.gazihalimi"
            ><i class="fab fa-instagram"></i
          ></a>
        </div>
      </div>
    </div>
  </div>

  <nav class="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
    <!-- <router-link to="/" class="navbar-brand">...</router-link> -->

    <router-link
      to="/"
      class="navbar-brand d-flex align-items-center px-4 px-lg-5"
    >
      <img
        style="width: 44px"
        class="img-fluid rounded"
        src="img/Gazi-logo_03.png"
        :alt="globalConfig.altPictureText"
      />
      <h1 class="ms-0 me-2">artenbau</h1>
      <h1 class="ms-0">Gazi</h1></router-link
    >

    <button class="navbar-toggler me-4" type="button" @click="toggleNavbar">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav ms-auto p-4 p-lg-0">
        <li>
          <router-link to="/" class="nav-link nav-item">Startseite</router-link>
        </li>

        <li>
          <router-link to="/about" class="nav-link nav-item"
            >Über uns</router-link
          >
        </li>

        <li>
          <router-link to="/projects" class="nav-link nav-item"
            >Projekte</router-link
          >
        </li>

        <li>
          <router-link to="/team" class="nav-link nav-item">Team</router-link>
        </li>

        <li>
          <router-link to="/contact" class="nav-link nav-item"
            >Kontakt</router-link
          >
        </li>
      </ul>
    </div>
  </nav>

  <!-- Navbar Start -->
  <!-- <nav class="navbar navbar-expand-lg bg-white navbar-light sticky-top p-0">
    <router-link
      to="/"
      class="navbar-brand d-flex align-items-center px-4 px-lg-5"
    >
      <img
        style="width: 44px"
        class="img-fluid rounded"
        src="img/Gazi-logo_03.png"
        :alt="globalConfig.altPictureText"
      />
      <h1 class="ms-0 me-2">artenbau</h1>
      <h1 class="ms-0">Gazi</h1></router-link
    >
    <button
      type="button"
      class="navbar-toggler me-4"
      data-bs-toggle="collapse"
      data-bs-target="#navbarCollapse"
      aria-controls="navbarCollapse"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarCollapse">
      <ul class="navbar-nav ms-auto p-4 p-lg-0">
        <li>
          <router-link to="/" class="nav-link nav-item">Startseite</router-link>
        </li>

        <li>
          <router-link to="/about" class="nav-link nav-item"
            >Über uns</router-link
          >
        </li>

        <li>
          <router-link to="/projects" class="nav-link nav-item"
            >Projekte</router-link
          >
        </li>

        <li>
          <router-link to="/team" class="nav-link nav-item">Team</router-link>
        </li>

        <li>
          <router-link to="/contact" class="nav-link nav-item"
            >Kontakt</router-link
          >
        </li>
      </ul>
    </div>
  </nav> -->
  <!-- Navbar End -->
</template>

<script setup>
import { onMounted } from 'vue';
import { Collapse } from 'bootstrap';
import config from '../../store/global.js';
const globalConfig = config.global().globalConfig;

let bsCollapse = null;

onMounted(() => {
  const el = document.getElementById('navbarCollapse');
  bsCollapse = new Collapse(el, { toggle: false }); // initialize manually
});

function toggleNavbar() {
  if (bsCollapse) {
    bsCollapse.toggle();
  }
}
</script>
